export const APPLICATION_KEYS = {
  publicKey: process.env.REACT_APP_VAPID_PUBLIC_KEY || "",
};
